import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, Teleport as _Teleport, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[9999] flex items-center justify-center p-3"
}
const _hoisted_2 = { class: "relative bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden" }
const _hoisted_3 = { class: "shrink-0 p-5 border-b border-gray-200 flex items-start justify-between gap-4" }
const _hoisted_4 = { class: "text-sm text-gray-600 mt-1" }
const _hoisted_5 = {
  class: "shrink-0 min-h-[52px] border-b border-gray-200 px-5 flex gap-1 overflow-x-auto",
  role: "tablist",
  "aria-label": "Configuration Shopify"
}
const _hoisted_6 = ["disabled", "aria-selected", "onClick"]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = { class: "min-h-0 flex-1 overflow-y-auto p-5 space-y-4" }
const _hoisted_10 = {
  key: 1,
  class: "max-w-xl space-y-4"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-50 p-3 cursor-pointer" }
const _hoisted_13 = { class: "min-w-0 flex-1" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 1,
  class: "block text-xs text-orange-900/80 break-all"
}
const _hoisted_16 = { class: "mt-3 flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-50 p-3 cursor-pointer" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 2,
  class: "space-y-5"
}
const _hoisted_19 = { class: "flex flex-wrap items-center justify-between gap-2 text-xs text-gray-500" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "text-sm text-gray-500",
  role: "status"
}
const _hoisted_22 = {
  key: 1,
  class: "text-sm text-blue-700"
}
const _hoisted_23 = {
  key: 2,
  class: "rounded-lg bg-amber-50 p-3 text-xs text-amber-800"
}
const _hoisted_24 = { class: "space-y-2" }
const _hoisted_25 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_26 = {
  key: 0,
  class: "text-sm text-green-700"
}
const _hoisted_27 = { class: "flex items-center gap-2 text-sm font-medium text-gray-900" }
const _hoisted_28 = ["title", "aria-label"]
const _hoisted_29 = {
  key: 1,
  class: "text-xs font-normal text-gray-600"
}
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = { class: "space-y-2" }
const _hoisted_32 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_33 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_34 = { class: "text-sm min-w-0" }
const _hoisted_35 = { class: "font-medium" }
const _hoisted_36 = { class: "flex items-center gap-3" }
const _hoisted_37 = ["disabled", "onClick"]
const _hoisted_38 = ["disabled", "onClick"]
const _hoisted_39 = { class: "border-t border-gray-100 pt-3" }
const _hoisted_40 = {
  key: 0,
  class: "mt-3 flex flex-wrap gap-2"
}
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "fixed inset-0 z-[10050] flex items-center justify-center p-3"
}
const _hoisted_43 = { class: "relative flex max-h-[85vh] w-full max-w-xl flex-col rounded-xl bg-white p-5 shadow-xl" }
const _hoisted_44 = { class: "flex items-start justify-between gap-4" }
const _hoisted_45 = { class: "font-semibold text-gray-900" }
const _hoisted_46 = { class: "text-sm text-gray-600 mt-1" }
const _hoisted_47 = {
  key: 0,
  class: "mt-3 rounded-lg bg-red-50 p-2 text-sm text-red-700"
}
const _hoisted_48 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_49 = {
  key: 2,
  class: "mt-5 flex min-h-0 flex-col gap-3"
}
const _hoisted_50 = { class: "min-h-0 overflow-y-auto rounded-lg border border-gray-200" }
const _hoisted_51 = ["disabled", "onClick"]
const _hoisted_52 = {
  key: 0,
  class: "p-3 text-sm text-gray-500"
}
const _hoisted_53 = {
  key: 3,
  class: "mt-5 min-h-0 overflow-y-auto space-y-3"
}
const _hoisted_54 = { class: "rounded-lg border border-gray-200" }
const _hoisted_55 = {
  key: 0,
  class: "border-t border-gray-200 p-3 space-y-2"
}
const _hoisted_56 = { class: "max-h-52 overflow-y-auto" }
const _hoisted_57 = ["disabled", "onClick"]
const _hoisted_58 = { class: "text-xs text-gray-500" }
const _hoisted_59 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_60 = { class: "rounded-lg border border-gray-200" }
const _hoisted_61 = {
  key: 0,
  class: "border-t border-gray-200 p-3 space-y-2"
}
const _hoisted_62 = ["disabled"]

import { computed, ref, watch } from "vue";
import CouleursPickerModal from "@/components/mel/CouleursPickerModal.vue";
import CategoryTreeAutocomplete from "@/components/forms/CategoryTreeAutocomplete.vue";
import { getCouleursOfficielles } from "@/api/couleurs";
import { getCategoriesTree } from "@/api/categories";
import {
  createShopifyBrandMapping, deleteShopifyMapping, getShopifyMappingTargets,
  getShopifyMappings, getShopifyPendingMappings, getShopifySettings, getShopifyProvenances,
  reregisterShopifyWebhooks, saveShopifyMapping, saveShopifySettings,
  type ShopifyMapping, type ShopifyMappingTarget, type ShopifyMappingType,
  type ShopifyPendingMappings, type ShopifySettings,
} from "@/api/shopify";
import { useAuthStore } from "@/stores/auth";
import type { CouleurAPI } from "@/types/mel-components";
import type { CategorieNode, CategoryPathSelection } from "@/types/categorie";

type Tab = "general" | ShopifyMappingType;

export default /*@__PURE__*/_defineComponent({
  __name: 'ShopifyConfigurationModal',
  props: {
    visible: { type: Boolean },
    shopUrl: {},
    requiredSetup: { type: Boolean },
    catalogReady: { type: Boolean },
    catalogRevision: {},
    pendingColors: {},
    pendingCategories: {},
    pendingCompositions: {},
    pendingBrands: {}
  },
  emits: ["update:visible", "changed", "settings-saved"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const authStore = useAuthStore();
const isAdmin = computed(() => authStore.isImpersonating);

const tabs: Array<{ id: Tab; label: string }> = [
  { id: "general", label: "Général" },
  { id: "color", label: "Couleurs" },
  { id: "category", label: "Catégories" },
  { id: "composition", label: "Compositions" },
  { id: "brand", label: "Marques" },
];
const tab = ref<Tab>("general");
const defaultGender = ref<"" | NonNullable<ShopifySettings["defaultGender"]>>("");
const savedGender = ref<ShopifySettings["defaultGender"]>(null);
const defaultProvenanceId = ref<number | "">("");
const autoSyncFromShopify = ref(false);
const autoSyncOrdersToShopify = ref(true);
const webhookInfo = ref("");
const webhookMessage = ref("");
const webhookMessageIsError = ref(false);
const savedProvenanceId = ref<number | null>(null);
const provenances = ref<Array<{ id: number; label: string }>>([]);
const mappings = ref<ShopifyMapping[]>([]);
const targets = ref<ShopifyMappingTarget[]>([]);
const pendingSummary = ref<ShopifyPendingMappings | null>(null);
const pendingLoading = ref(false);
const loading = ref(false);
const busy = ref(false);
const message = ref("");
const messageIsError = ref(false);
const pickerVisible = ref(false);
const colorPickerVisible = ref(false);
const pickerSource = ref("");
const pickerSearch = ref("");
const brandName = ref("");
const brandListOpen = ref(true);
const brandCreateOpen = ref(false);
const manualOpen = ref(false);
const manualSource = ref("");
const officialColors = ref<CouleurAPI[]>([]);
const categoriesTree = ref<CategorieNode[]>([]);
let loadSequence = 0;
let pendingSequence = 0;
const resolvedDuringScan = new Map<ShopifyMappingType, Set<string>>();

const pendingByType = computed(() => pendingSummary.value || {
  color: props.pendingColors, category: props.pendingCategories,
  composition: props.pendingCompositions, brand: props.pendingBrands,
  colorHexByName: {},
  scannedProducts: 0, incomplete: false,
});
const pending = computed(() => tab.value === "general" ? [] : pendingByType.value[tab.value]);
const chooseLabel = computed(() => tab.value === "color" ? "Choisir une couleur" :
  tab.value === "category" ? "Choisir une catégorie" :
  tab.value === "composition" ? "Choisir une matière" : "Choisir une marque");
const filteredTargets = computed(() => {
  const search = normalize(pickerSearch.value);
  const rows = search ? targets.value.filter((target) => normalize(target.label).includes(search)) : targets.value;
  if (tab.value !== "brand" || search) return rows;
  const source = normalize(pickerSource.value);
  const sourceWords = new Set(source.split(" ").filter((word) => word.length > 2 && word !== "b2b"));
  return [...rows].sort((left, right) => {
    const score = (target: ShopifyMappingTarget) =>
      normalize(target.label).split(" ").filter((word) => sourceWords.has(word)).length +
      (normalize(target.label) === source ? 10 : 0);
    return score(right) - score(left) || Number(right.isDefault) - Number(left.isDefault) ||
      left.label.localeCompare(right.label, "fr");
  });
});

function normalize(value: string) {
  return String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
}
function pendingCount(type: Tab) {
  return type === "general" ? 0 : pendingByType.value[type].length;
}
function colorHex(label: string): string | null {
  const hex = pendingByType.value.colorHexByName[normalize(label)];
  return /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i.test(hex || "") ? hex : null;
}
function clearPending(type: ShopifyMappingType, source: string) {
  if (pendingLoading.value) {
    const resolved = resolvedDuringScan.get(type) || new Set<string>();
    resolved.add(normalize(source));
    resolvedDuringScan.set(type, resolved);
  }
  if (pendingSummary.value) {
    pendingSummary.value = {
      ...pendingSummary.value,
      [type]: pendingSummary.value[type].filter((label) => normalize(label) !== normalize(source)),
    };
  }
}
function showMessage(value: string, isError = false) {
  message.value = value;
  messageIsError.value = isError;
}
function close() {
  if (!props.requiredSetup && !busy.value) emit("update:visible", false);
}
async function loadPending(force = false) {
  if (!props.catalogReady) return;
  if ((pendingLoading.value || pendingSummary.value) && !force) return;
  const sequence = ++pendingSequence;
  resolvedDuringScan.clear();
  pendingLoading.value = true;
  try {
    const summary = await getShopifyPendingMappings();
    if (sequence === pendingSequence) {
      for (const type of ["color", "category", "composition", "brand"] as const) {
        const resolved = resolvedDuringScan.get(type);
        if (resolved) summary[type] = summary[type].filter((label) => !resolved.has(normalize(label)));
      }
      pendingSummary.value = summary;
    }
  } catch (caught) {
    if (sequence === pendingSequence)
      showMessage(caught instanceof Error ? caught.message : "Catalogue Shopify indisponible.", true);
  } finally {
    if (sequence === pendingSequence) {
      pendingLoading.value = false;
      resolvedDuringScan.clear();
    }
  }
}
async function loadTab(type: ShopifyMappingType) {
  const sequence = ++loadSequence;
  loading.value = true;
  try {
    const [nextMappings, nextTargets] = await Promise.all([
      getShopifyMappings(type), getShopifyMappingTargets(type),
    ]);
    if (sequence === loadSequence) {
      mappings.value = nextMappings;
      targets.value = nextTargets;
    }
  } catch (caught) {
    if (sequence === loadSequence)
      showMessage(caught instanceof Error ? caught.message : "Chargement impossible.", true);
  } finally {
    if (sequence === loadSequence) loading.value = false;
  }
}
function selectTab(value: Tab) {
  if (busy.value || (props.requiredSetup && value !== "general")) return;
  tab.value = value;
  pickerVisible.value = false;
  colorPickerVisible.value = false;
  showMessage("");
  if (value === "general") {
    loadSequence += 1;
    loading.value = false;
  } else void loadTab(value);
}
async function saveGeneral() {
  if (!defaultGender.value || !defaultProvenanceId.value || busy.value) return;
  busy.value = true;
  try {
    const settings = await saveShopifySettings(
      defaultGender.value,
      Number(defaultProvenanceId.value),
      autoSyncFromShopify.value,
      autoSyncOrdersToShopify.value,
    );
    const settingChanged = savedGender.value !== settings.defaultGender ||
      savedProvenanceId.value !== settings.defaultProvenanceId;
    savedGender.value = settings.defaultGender;
    savedProvenanceId.value = settings.defaultProvenanceId;
    autoSyncFromShopify.value = Boolean(settings.autoSyncFromShopify);
    autoSyncOrdersToShopify.value = settings.autoSyncOrdersToShopify !== false;
    emit("settings-saved", settings);
    emit("changed");
    showMessage("Configuration enregistrée.");
    if (settingChanged) {
      pendingSummary.value = null;
      if (pendingLoading.value) {
        pendingSequence += 1;
        pendingLoading.value = false;
      }
      if (!props.requiredSetup) void loadPending(true);
    }
  } catch (caught) {
    showMessage(caught instanceof Error ? caught.message : "Enregistrement impossible.", true);
  } finally {
    busy.value = false;
  }
}
async function reregisterWebhooks() {
  if (busy.value) return;
  busy.value = true;
  webhookInfo.value = "";
  webhookMessage.value = "";
  webhookMessageIsError.value = false;
  try {
    const result = await reregisterShopifyWebhooks();
    const topics = result.subscriptions.map((item) => item.topic).join(", ") || "(aucun)";
    webhookInfo.value = `URL : ${result.callbackUrl} — sujets : ${topics}`;
    webhookMessage.value = "Webhooks réenregistrés.";
    webhookMessageIsError.value = false;
  } catch (caught) {
    webhookMessage.value = caught instanceof Error
      ? caught.message
      : "Réenregistrement des webhooks impossible.";
    webhookMessageIsError.value = true;
  } finally {
    busy.value = false;
  }
}
async function openPicker(source: string) {
  if (tab.value === "general" || busy.value || loading.value) return;
  busy.value = true;
  pickerSource.value = source;
  pickerSearch.value = "";
  brandName.value = source;
  brandListOpen.value = true;
  brandCreateOpen.value = false;
  try {
    if (tab.value === "color") {
      if (!officialColors.value.length) officialColors.value = await getCouleursOfficielles();
      colorPickerVisible.value = true;
    } else {
      if (tab.value === "category" && !categoriesTree.value.length)
        categoriesTree.value = await getCategoriesTree();
      pickerVisible.value = true;
    }
  } catch (caught) {
    showMessage(caught instanceof Error ? caught.message : "Sélecteur indisponible.", true);
  } finally {
    busy.value = false;
  }
}
async function savePickedTarget(targetId: number) {
  if (tab.value === "general" || busy.value || !pickerSource.value) return;
  busy.value = true;
  try {
    await saveShopifyMapping(tab.value, pickerSource.value, targetId);
    clearPending(tab.value, pickerSource.value);
    pickerVisible.value = false;
    colorPickerVisible.value = false;
    manualSource.value = "";
    await loadTab(tab.value);
    emit("changed");
    showMessage("Correspondance enregistrée.");
  } catch (caught) {
    showMessage(caught instanceof Error ? caught.message : "Enregistrement impossible.", true);
  } finally {
    busy.value = false;
  }
}
function onColorConfirm(colors: CouleurAPI[]) {
  const color = colors[0];
  colorPickerVisible.value = false;
  if (color) void savePickedTarget(color.id_couleur);
}
function onCategorySelect(path: CategoryPathSelection) {
  const targetId = Number(path.leafId);
  if (targetId) void savePickedTarget(targetId);
}
async function createBrand() {
  if (tab.value !== "brand" || busy.value || !brandName.value) return;
  busy.value = true;
  try {
    const result = await createShopifyBrandMapping(pickerSource.value, brandName.value);
    clearPending("brand", pickerSource.value);
    pickerVisible.value = false;
    manualSource.value = "";
    await loadTab("brand");
    emit("changed");
    showMessage(result.createdBrand ? "Marque créée et liée." : "Marque existante liée.");
  } catch (caught) {
    showMessage(caught instanceof Error ? caught.message : "Création impossible.", true);
  } finally {
    busy.value = false;
  }
}
async function remove(row: ShopifyMapping) {
  if (tab.value === "general" || busy.value) return;
  busy.value = true;
  try {
    await deleteShopifyMapping(tab.value, row.sourceLabel);
    await loadTab(tab.value);
    if (pendingLoading.value) {
      pendingSequence += 1;
      pendingLoading.value = false;
    }
    void loadPending(true);
    emit("changed");
    showMessage("Correspondance supprimée.");
  } catch (caught) {
    showMessage(caught instanceof Error ? caught.message : "Suppression impossible.", true);
  } finally {
    busy.value = false;
  }
}

watch(() => props.visible, async (visible) => {
  if (!visible) return;
  tab.value = "general";
  loadSequence += 1;
  loading.value = false;
  showMessage("");
  try {
    const [settings, provenanceOptions] = await Promise.all([getShopifySettings(), getShopifyProvenances()]);
    provenances.value = provenanceOptions;
    defaultGender.value = settings.defaultGender || "";
    savedGender.value = settings.defaultGender;
    defaultProvenanceId.value = provenanceOptions.some((option) => option.id === settings.defaultProvenanceId)
      ? Number(settings.defaultProvenanceId) : "";
    savedProvenanceId.value = settings.defaultProvenanceId;
    autoSyncFromShopify.value = Boolean(settings.autoSyncFromShopify);
    autoSyncOrdersToShopify.value = settings.autoSyncOrdersToShopify !== false;
    if (!props.requiredSetup) void loadPending();
  } catch (caught) {
    showMessage(caught instanceof Error ? caught.message : "Configuration indisponible.", true);
  }
});
watch(() => props.shopUrl, () => {
  pendingSequence += 1;
  pendingSummary.value = null;
  pendingLoading.value = false;
  resolvedDuringScan.clear();
});
watch(() => props.catalogRevision, () => {
  pendingSummary.value = null;
  if (props.visible && !props.requiredSetup) void loadPending(true);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (!_ctx.requiredSetup)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "absolute inset-0 bg-black/50",
                  "aria-label": "Fermer la configuration Shopify",
                  onClick: close
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "text-lg font-semibold text-black" }, "Configuration Shopify", -1)),
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.requiredSetup ? "Choisissez le genre et le pays de provenance avant le premier import." : "Associez une fois les libellés Shopify à vos valeurs eFashion."), 1)
                ]),
                (!_ctx.requiredSetup)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "text-gray-500",
                      "aria-label": "Fermer",
                      onClick: close
                    }, _cache[18] || (_cache[18] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (item) => {
                  return _createElementVNode("button", {
                    key: item.id,
                    type: "button",
                    role: "tab",
                    class: _normalizeClass(["shrink-0 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 flex items-center gap-1.5", tab.value === item.id ? 'border-green-600 text-green-700' : 'border-transparent text-gray-600']),
                    disabled: busy.value || (_ctx.requiredSetup && item.id !== 'general'),
                    "aria-selected": tab.value === item.id,
                    onClick: ($event: any) => (selectTab(item.id))
                  }, [
                    _createTextVNode(_toDisplayString(item.label) + " ", 1),
                    (item.id !== 'general' && pendingCount(item.id))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "inline-flex items-center gap-1 text-red-600",
                          "aria-label": pendingCount(item.id) + ' correspondances à traiter'
                        }, [
                          _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-exclamation-circle text-xs" }, null, -1)),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(pendingCount(item.id)), 1)
                        ], 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_6)
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_9, [
                (message.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["text-sm rounded-lg p-3", messageIsError.value ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'])
                    }, _toDisplayString(message.value), 3))
                  : _createCommentVNode("", true),
                (tab.value === 'general')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", {
                        class: "block text-sm font-medium text-gray-800",
                        for: "shopify-default-gender"
                      }, "Genre par défaut", -1)),
                      _withDirectives(_createElementVNode("select", {
                        id: "shopify-default-gender",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((defaultGender).value = $event)),
                        class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                      }, _cache[20] || (_cache[20] = [
                        _createElementVNode("option", { value: "" }, "Choisir un genre", -1),
                        _createElementVNode("option", { value: "femme" }, "Femme", -1),
                        _createElementVNode("option", { value: "homme" }, "Homme", -1),
                        _createElementVNode("option", { value: "enfant" }, "Enfant", -1),
                        _createElementVNode("option", { value: "aucun" }, "Plusieurs genres / aucun genre par défaut", -1)
                      ]), 512), [
                        [_vModelSelect, defaultGender.value]
                      ]),
                      _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-xs text-gray-600" }, "Cette préférence aide à proposer une catégorie. Les catégories ambiguës restent à valider.", -1)),
                      _cache[28] || (_cache[28] = _createElementVNode("label", {
                        class: "block text-sm font-medium text-gray-800",
                        for: "shopify-default-provenance"
                      }, "Pays de provenance par défaut", -1)),
                      _withDirectives(_createElementVNode("select", {
                        id: "shopify-default-provenance",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((defaultProvenanceId).value = $event)),
                        class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                      }, [
                        _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "Choisir un pays", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provenances.value, (provenance) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: provenance.id,
                            value: provenance.id
                          }, _toDisplayString(provenance.label), 9, _hoisted_11))
                        }), 128))
                      ], 512), [
                        [
                          _vModelSelect,
                          defaultProvenanceId.value,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-xs text-gray-600" }, "Ce pays est utilisé seulement si Shopify ne renseigne pas une provenance reconnue pour le produit.", -1)),
                      _createElementVNode("label", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((autoSyncFromShopify).value = $event)),
                          type: "checkbox",
                          class: "mt-0.5 h-4 w-4 rounded border-gray-300 text-green-600 focus:ring-green-500"
                        }, null, 512), [
                          [_vModelCheckbox, autoSyncFromShopify.value]
                        ]),
                        _createElementVNode("span", _hoisted_13, [
                          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "block text-sm font-medium text-gray-800" }, " Mettre à jour automatiquement les produits depuis Shopify ", -1)),
                          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "mt-0.5 block text-xs text-gray-600" }, " Dès qu’un changement intervient sur Shopify, tous les produits déjà liés sont mis à jour dans eFashion (prix, poids, titre/description, provenance, stock). Les photos ne sont pas resynchronisées automatiquement. ", -1)),
                          (isAdmin.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "mt-3 block rounded-lg border border-orange-300 bg-orange-50 p-3 space-y-2",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                              }, [
                                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "block text-xs font-medium text-orange-800" }, " Visible uniquement aux administrateurs ", -1)),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "rounded-lg bg-orange-500 px-3 py-1.5 text-sm font-medium text-white hover:bg-orange-600 disabled:opacity-50",
                                  disabled: busy.value,
                                  onClick: reregisterWebhooks
                                }, " Réenregistrer les webhooks ", 8, _hoisted_14),
                                (webhookMessage.value)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["block rounded-md px-2 py-1.5 text-xs", webhookMessageIsError.value ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700']),
                                      role: "status"
                                    }, _toDisplayString(webhookMessage.value), 3))
                                  : _createCommentVNode("", true),
                                (webhookInfo.value && !webhookMessageIsError.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(webhookInfo.value), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("label", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((autoSyncOrdersToShopify).value = $event)),
                          type: "checkbox",
                          class: "mt-0.5 h-4 w-4 rounded border-gray-300 text-green-600 focus:ring-green-500"
                        }, null, 512), [
                          [_vModelCheckbox, autoSyncOrdersToShopify.value]
                        ]),
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "min-w-0 flex-1" }, [
                          _createElementVNode("span", { class: "block text-sm font-medium text-gray-800" }, " Envoyer automatiquement les commandes vers Shopify "),
                          _createElementVNode("span", { class: "mt-0.5 block text-xs text-gray-600" }, " Jusqu’à 5 commandes, toutes les 5 minutes. ")
                        ], -1))
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-50",
                        disabled: busy.value || !defaultGender.value || !defaultProvenanceId.value,
                        onClick: saveGeneral
                      }, _toDisplayString(busy.value ? "Enregistrement…" : "Enregistrer la configuration"), 9, _hoisted_17)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[31] || (_cache[31] = _createElementVNode("span", null, "Les correspondances sont calculées depuis le catalogue enregistré.", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "text-blue-700 hover:underline disabled:opacity-50",
                          disabled: pendingLoading.value || busy.value,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (loadPending(true)))
                        }, _cache[30] || (_cache[30] = [
                          _createElementVNode("i", { class: "fas fa-sync-alt mr-1" }, null, -1),
                          _createTextVNode(" Recalculer les correspondances ")
                        ]), 8, _hoisted_20)
                      ]),
                      (pendingLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _cache[32] || (_cache[32] = [
                            _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-1" }, null, -1),
                            _createTextVNode(" Analyse du catalogue enregistré en cours… ")
                          ])))
                        : _createCommentVNode("", true),
                      (!_ctx.catalogReady)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_22, "Le catalogue se synchronise. Les correspondances apparaîtront une fois la copie terminée."))
                        : _createCommentVNode("", true),
                      (pendingSummary.value?.incomplete)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, " Le catalogue est très volumineux : les alertes couvrent les " + _toDisplayString(pendingSummary.value.scannedProducts) + " premiers produits. ", 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("h3", _hoisted_25, "À lier " + _toDisplayString(pending.value.length ? "(" + pending.value.length + ")" : ""), 1),
                        (!pending.value.length && !pendingLoading.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(pendingSummary.value ? "Toutes les valeurs détectées sont liées." : "Aucune correspondance détectée pour le moment."), 1))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pending.value, (label) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: label,
                            class: "flex flex-wrap items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 p-3"
                          }, [
                            _createElementVNode("span", _hoisted_27, [
                              (tab.value === 'color' && colorHex(label))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "inline-block h-6 w-6 shrink-0 rounded-full border border-gray-400 shadow-sm",
                                    style: _normalizeStyle({ backgroundColor: colorHex(label) || undefined }),
                                    title: colorHex(label) || undefined,
                                    "aria-label": 'Couleur Shopify ' + colorHex(label)
                                  }, null, 12, _hoisted_28))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", null, _toDisplayString(label), 1),
                              (tab.value === 'color' && colorHex(label))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(colorHex(label)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "rounded-lg border border-red-300 bg-white px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100",
                              disabled: busy.value || loading.value,
                              onClick: ($event: any) => (openPicker(label))
                            }, _toDisplayString(chooseLabel.value), 9, _hoisted_30)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, "Correspondances enregistrées", -1)),
                        (loading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Chargement…"))
                          : (!mappings.value.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, "Aucune correspondance enregistrée."))
                            : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mappings.value, (row) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: row.sourceLabelNormalized,
                            class: "flex flex-wrap items-center justify-between gap-3 rounded-lg border border-gray-200 p-3"
                          }, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("span", _hoisted_35, _toDisplayString(row.sourceLabel), 1),
                              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "mx-2 text-gray-400" }, "→", -1)),
                              _createElementVNode("span", null, _toDisplayString(row.targetLabel || "#" + row.targetId), 1)
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-sm text-blue-700 hover:underline",
                                disabled: busy.value || loading.value,
                                onClick: ($event: any) => (openPicker(row.sourceLabel))
                              }, "Modifier", 8, _hoisted_37),
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-sm text-red-700 hover:underline",
                                disabled: busy.value,
                                onClick: ($event: any) => (remove(row))
                              }, "Supprimer", 8, _hoisted_38)
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "text-xs text-gray-600 hover:underline",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (manualOpen.value = !manualOpen.value))
                        }, _toDisplayString(manualOpen.value ? "Masquer l'ajout manuel" : "Ajouter un libellé Shopify absent de cette liste"), 1),
                        (manualOpen.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((manualSource).value = $event)),
                                type: "text",
                                maxlength: "255",
                                "aria-label": "Libellé Shopify",
                                placeholder: "Libellé Shopify",
                                class: "flex-1 min-w-[180px] rounded-lg border border-gray-300 px-3 py-2 text-sm"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  manualSource.value,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "rounded-lg bg-gray-800 px-3 py-2 text-sm text-white disabled:opacity-50",
                                disabled: !manualSource.value || busy.value || loading.value,
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (openPicker(manualSource.value)))
                              }, "Choisir une valeur", 8, _hoisted_41)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    _createVNode(CouleursPickerModal, {
      isVisible: colorPickerVisible.value,
      "onUpdate:isVisible": _cache[9] || (_cache[9] = ($event: any) => ((colorPickerVisible).value = $event)),
      "couleurs-list": officialColors.value,
      "official-only": true,
      "selected-ids": [],
      onConfirm: onColorConfirm
    }, null, 8, ["isVisible", "couleurs-list"]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (pickerVisible.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("button", {
              type: "button",
              class: "absolute inset-0 bg-black/50",
              "aria-label": "Fermer le choix",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (pickerVisible.value = false))
            }),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_45, _toDisplayString(chooseLabel.value), 1),
                  _createElementVNode("p", _hoisted_46, [
                    _cache[35] || (_cache[35] = _createTextVNode("Valeur Shopify : ")),
                    _createElementVNode("strong", null, _toDisplayString(pickerSource.value), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  "aria-label": "Fermer",
                  class: "text-gray-500",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (pickerVisible.value = false))
                }, _cache[36] || (_cache[36] = [
                  _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                ]))
              ]),
              (messageIsError.value && message.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(message.value), 1))
                : _createCommentVNode("", true),
              (tab.value === 'category')
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createVNode(CategoryTreeAutocomplete, {
                      tree: categoriesTree.value,
                      "cat-id": "",
                      "sous-id": "",
                      "sous-sous-id": "",
                      label: "Catégorie eFashion",
                      placeholder: "Rechercher une catégorie feuille…",
                      onSelect: onCategorySelect
                    }, null, 8, ["tree"])
                  ]))
                : (tab.value === 'composition')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((pickerSearch).value = $event)),
                        type: "search",
                        "aria-label": "Rechercher une matière",
                        placeholder: "Rechercher une matière",
                        class: "rounded-lg border border-gray-300 px-3 py-2 text-sm"
                      }, null, 512), [
                        [
                          _vModelText,
                          pickerSearch.value,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTargets.value, (target) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: target.id,
                            type: "button",
                            class: "block w-full border-b border-gray-100 px-3 py-2 text-left text-sm hover:bg-green-50",
                            disabled: busy.value,
                            onClick: ($event: any) => (savePickedTarget(target.id))
                          }, _toDisplayString(target.label), 9, _hoisted_51))
                        }), 128)),
                        (!filteredTargets.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_52, "Aucune matière trouvée."))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (tab.value === 'brand')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "w-full px-3 py-2 text-left text-sm font-medium flex justify-between",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (brandListOpen.value = !brandListOpen.value))
                          }, [
                            _createTextVNode(" Choisir une marque existante (" + _toDisplayString(targets.value.length) + ") ", 1),
                            _cache[37] || (_cache[37] = _createElementVNode("i", { class: "fas fa-chevron-down text-xs" }, null, -1))
                          ]),
                          (brandListOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((pickerSearch).value = $event)),
                                  type: "search",
                                  "aria-label": "Rechercher une marque",
                                  placeholder: "Rechercher une marque",
                                  class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    pickerSearch.value,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createElementVNode("div", _hoisted_56, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTargets.value, (target) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      key: target.id,
                                      type: "button",
                                      class: "block w-full rounded-md px-3 py-2 text-left text-sm hover:bg-green-50",
                                      disabled: busy.value,
                                      onClick: ($event: any) => (savePickedTarget(target.id))
                                    }, [
                                      _createTextVNode(_toDisplayString(target.label) + " ", 1),
                                      _createElementVNode("span", _hoisted_58, "#" + _toDisplayString(target.id) + _toDisplayString(target.isDefault ? " · par défaut" : ""), 1)
                                    ], 8, _hoisted_57))
                                  }), 128)),
                                  (!filteredTargets.value.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_59, "Aucune marque trouvée."))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "w-full px-3 py-2 text-left text-sm font-medium flex justify-between",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (brandCreateOpen.value = !brandCreateOpen.value))
                          }, _cache[38] || (_cache[38] = [
                            _createTextVNode(" Créer une nouvelle marque "),
                            _createElementVNode("i", { class: "fas fa-chevron-down text-xs" }, null, -1)
                          ])),
                          (brandCreateOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                _cache[39] || (_cache[39] = _createElementVNode("label", {
                                  for: "shopify-new-brand",
                                  class: "block text-xs text-gray-600"
                                }, "Nom de la nouvelle marque", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  id: "shopify-new-brand",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((brandName).value = $event)),
                                  maxlength: "255",
                                  type: "text",
                                  class: "w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    brandName.value,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "rounded-lg bg-green-600 px-3 py-2 text-sm text-white disabled:opacity-50",
                                  disabled: busy.value || !brandName.value,
                                  onClick: createBrand
                                }, "Créer et lier", 8, _hoisted_62)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})